import React, { useState } from "react";
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const dayWithSuffix =
    day +
    (day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? ""
      : "");
  return `${dayWithSuffix} ${month} ${year}`;
};
const AddGuestModal = ({ isOpen,eventDetailData, onClose, handleSubmit }) => {
  const [spouseList, setSpouseList] = useState([{ name: "", contact: "" }]);
  const [guestList, setGuestList] = useState([{ name: "", contact: "" }]);
 console.log(eventDetailData)
  // Add a new spouse field (max 3)
  const handleAddSpouse = () => {
    if (spouseList.length < 3) {
      setSpouseList([...spouseList, { name: "", contact: "" }]);
    }
  };
  const handleRemoveSpouse = (index) => {
    const updatedSpouseList = spouseList.filter((_, i) => i !== index);
    setSpouseList(updatedSpouseList);
    
    // Update localStorage
    localStorage.setItem('userSpouseList', JSON.stringify(updatedSpouseList));
  };

  // Remove a spouse field
  
  // Add a new guest field (max 3)
  const handleAddGuest = () => {
    if (guestList.length < 3) {
      setGuestList([...guestList, { name: "", contact: "" }]);
    }
  };

  // Remove a guest field
  const handleRemoveGuest = (index) => {
    const updatedGuestList = guestList.filter((_, i) => i !== index);
    setGuestList(updatedGuestList);
    
    // Update localStorage
    localStorage.setItem('userGuestList', JSON.stringify(updatedGuestList));
  };
 

  // Handle changes for spouse fields
  const handleSpouseChange = (index, field, value) => {
    const updatedSpouseList = spouseList.map((spouse, i) =>
      i === index ? { ...spouse, [field]: value } : spouse
    );
    setSpouseList(updatedSpouseList);
    
    // Store as a JSON string
    localStorage.setItem('userSpouseList', JSON.stringify(updatedSpouseList));
  };
  
  // Handle changes for guest fields
  const handleGuestChange = (index, field, value) => {
    const updatedGuestList = guestList.map((guest, i) =>
      i === index ? { ...guest, [field]: value } : guest
    );
    setGuestList(updatedGuestList);
  
    // Store as a JSON string
    localStorage.setItem('userGuestList', JSON.stringify(updatedGuestList));
  };
  

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Add Guest</h3>
        {/* Fixed Event Details */}
        <div className="event-details">
          <h4>{eventDetailData.title}</h4>
          <p>
            <strong>Date:</strong> {formatDate(eventDetailData.eventDate)}
          </p>
          <p>
            <strong>Time:</strong> {formatDate(eventDetailData.startTime)} - {formatDate(eventDetailData.endTime)}
          </p>
          <p>
            <strong>Location:</strong> {eventDetailData.address}
          </p>
          <p>
            <strong>Charges:</strong>
            <br />
            For Spouse & Guardian: Rs. {eventDetailData.spouseFee}/-
            <br />
            For Guest: Rs. {eventDetailData.guestFee}/-
          </p>
        </div>

        {/* Scrollable Section for Spouse/Guardian and Guest */}
        <div className="scrollable-content">
          {/* Spouse/Guardian Section */}
          <div className="form-section">
            <h5>
              + Add Spouse/Guardian{" "}
              <button
                onClick={handleAddSpouse}
                disabled={spouseList.length >= 3}
                className="add-button"
              >
                +
              </button>
            </h5>
            {spouseList.map((spouse, index) => (
              <div key={index} className="input-group">
                <input
                  type="text"
                  placeholder="Enter Spouse Name"
                  value={spouse.name}
                  onChange={(e) =>
                    handleSpouseChange(index, "name", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Enter Contact No."
                  value={spouse.contact}
                  onChange={(e) =>
                    handleSpouseChange(index, "contact", e.target.value)
                  }
                />
                <button
                  onClick={() => handleRemoveSpouse(index)}
                  className="remove-button"
                >
                  -
                </button>
              </div>
            ))}
          </div>

          {/* Guest Section */}
          <div className="form-section">
            <h5>
              + Add Guest{" "}
              <button
                onClick={handleAddGuest}
                disabled={guestList.length >= 3}
                className="add-button"
              >
                +
              </button>
            </h5>
            {guestList.map((guest, index) => (
              <div key={index} className="input-group">
                <input
                  type="text"
                  placeholder="Enter Guest Name"
                  value={guest.name}
                  onChange={(e) =>
                    handleGuestChange(index, "name", e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Enter Contact No."
                  value={guest.contact}
                  onChange={(e) =>
                    handleGuestChange(index, "contact", e.target.value)
                  }
                />
                <button
                  onClick={() => handleRemoveGuest(index)}
                  className="remove-button"
                >
                  -
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Fixed Action Buttons */}
        <div className="button-group">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="continue-button" onClick={handleSubmit}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGuestModal;
